import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_GOOGLE_SUCCESS,
  DELETE_GOOGLE_SUCCESS,
  GET_GOOGLE_FAIL,
  GET_GOOGLE_SUCCESS,
  UPDATE_GOOGLE_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  google: [],
  defective: [],
  exports: [],
  total: 0,
  pagination: { page: 1, per_page: 10, search: "" },
  error: {},
};

const GOOGLE = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GOOGLE_SUCCESS:
      return {
        ...state,
        ...(action.payload.google !== undefined && {
          google: action.payload.google,
        }),
        ...(action.payload.defective !== undefined && {
          defective: action.payload.defective,
        }),
        total: action.payload.total ?? state.total,
        pagination: {
          page: action.payload.page ?? state.pagination.page,
          per_page: action.payload.per_page ?? state.pagination.per_page,
          search: action.payload.search ?? state.pagination.search,
        },
      };

    case GET_GOOGLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_GOOGLE_SUCCESS:
      return {
        ...state,
        google: [...state.google, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_GOOGLE_SUCCESS:
      return {
        ...state,
        google: state.google.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_GOOGLE_SUCCESS:
      return {
        ...state,
        google: state.google.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default GOOGLE;
